<template>
  <div class="User-MyUsers">
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'min-height:400px;overflow:hidden;' : ''">
      <div class="User-MyUsers-Nav">
      <div class="User-MyUsers-Header">
        <div class="User-MyUsers-Header-Title">
          {{ $t('EMP_UserSetting_ManageUsers') }}
        </div>
        <div class="User-MyUsers-Header-Tips">
          <div class="User-MyUsers-Header-Tips-Title">
            {{ $t('EMP_UserSetting_MasterAccount') }}
          </div>
          <div class="User-MyUsers-Header-Tips-P" ref="masterAccountTipContainer" v-html="masterAccountTipWithLink" @click="handleTipContainerClick"></div>
        </div>
      </div>
      <div class="User-MyUsers-Password">
        <div class="User-MyUsers-Password-Left">
          <i class="UserSetting_Password_Icon"></i>
          <div class="User-MyUsers-Password-Content">
            <div class="User-MyUsers-Password-Note">
              {{ $t('EMP_UserSetting_MasterPasswordMaskedNote') }}
            </div>
            <div class="User-MyUsers-Password-Masked">
              *********
            </div>
          </div>
        </div>
        <div class="User-MyUsers-Password-Right">
          <b-button variant="outline-primary" v-bind:t_label="'EMP_UserSetting_RetrievePassword'" @click="RetrieveFunc">
            {{ $t('EMP_UserSetting_RetrievePassword') }}
          </b-button>
        </div>
      </div>
      <div class="User-MyUsers-Users">
        <div class="User-MyUsers-Users-Head">
          <div class="User-MyUsers-Header-Tips">
            <div class="User-MyUsers-Header-Tips-Title">
              <template v-if="roleQuotaLimit !== null && Number(roleQuotaLimit) >= 0">
                {{ $t('EMP_UserSetting_UsersWithQuota', { activeAccount: roleQuotaUsed, quota: roleQuotaLimit }) }}
              </template>
              <template v-else>
                {{ $t('EMP_UserSetting_Users') }}
              </template>
            </div>
            <div class="User-MyUsers-Header-Tips-P">
              {{ $t('EMP_UserSetting_UsersTip') }}
            </div>
          </div>
          <b-button
            variant="primary"
            class="User-MyUsers-AddBtn d-flex align-items-center"
            v-bind:t_label="'EMP_UserSetting_AddUser'"
            @click="ShowDialogFunc(0)"
          >
            <feather type="plus" stroke="#fff"></feather>
            &nbsp; {{ $t('EMP_UserSetting_AddUser') }}
          </b-button>
        </div>

        <div class="User-MyUsers-Tabs" role="tablist">
          <button
            type="button"
            class="User-MyUsers-Tab"
            :class="{ 'is-active': userTab === 'active' }"
            role="tab"
            @click="userTab = 'active'"
          >
            {{ $t('EMP_UserSetting_Tab_Active', { activeAccount: activeUserList.length }) }}
          </button>
          <button
            type="button"
            class="User-MyUsers-Tab"
            :class="{ 'is-active': userTab === 'inactive' }"
            role="tab"
            @click="userTab = 'inactive'"
          >
            {{ $t('EMP_UserSetting_Tab_Inactive', { inactiveAccount: inactiveUserList.length }) }}
          </button>
        </div>

        <!-- 名额用尽：与销售线索 no-quota 同款紫条（仅有效页签 + 无剩余名额） -->
        <div
          v-if="showRoleQuotaNoQuotaBanner"
          class="role-quota-noQuota-banner"
        >
          <div class="role-quota-noQuota-banner__nav">
            <img
              class="role-quota-noQuota-banner__icon"
              :src="roleQuotaLockImg"
              alt=""
            />
            <div class="role-quota-noQuota-banner__body">
              <div class="role-quota-noQuota-banner__title">
                {{ $t('EMP_UserSetting_NoQuotaBanner_Title') }}
              </div>
              <div class="role-quota-noQuota-banner__desc">
                {{ $t('EMP_UserSetting_NoQuotaBanner_Desc') }}
              </div>
            </div>
          </div>
          <div class="role-quota-noQuota-banner__actions">
            <a
              class="role-quota-noQuota-banner__learn"
              :href="roleQuotaUpgradeUrl"
              target="_blank"
              rel="noopener"
              t_label="EMPBE_UserSetting_NoQuota_LearnMore"
            >{{ $t('lbl_EMPBE_SalesLead_LearnMore') }}</a>
            <a
              href="javascript:void(0)"
              class="role-quota-noQuota-banner__sales"
              t_label="EMPBE_UserSetting_NoQuota_ContactSales"
              @click.prevent="openContactUsModal"
            >{{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}</a>
          </div>
        </div>

        <!-- Reminder：到期前黄条 -->
        <div
          v-if="showEpoReminderBanner"
          class="epo-banner epo-banner--reminder"
        >
          <img
            class="epo-banner__plan-icon"
            :src="epoRemindIconSrc"
            width="40"
            height="40"
            alt=""
          />
          <div class="epo-banner__message">
            <div class="epo-banner__body">
              <div class="epo-banner__title">
                {{ $t('lbl_EMPBE_EPO_ReminderBanner_Title', epoCopyParams) }}
              </div>
              <div class="epo-banner__text">
                {{ $t('lbl_EMPBE_EPO_ReminderBanner_Body', epoCopyParams) }}
              </div>
            </div>
            <button
              type="button"
              class="epo-banner__cta"
              :t_label="'EMPBE_EPO_MyUsers_ContactSales_Reminder' + epoTrackSuffix"
              @click="openContactUsModal"
            >
              {{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}
            </button>
          </div>
        </div>

        <!-- Action：到期后粉条 [T, T+7) -->
        <div
          v-if="showEpoActionBanner"
          class="epo-banner epo-banner--action"
        >
          <img
            class="epo-banner__plan-icon"
            :src="epoActionIconSrc"
            width="40"
            height="40"
            alt=""
          />
          <div class="epo-banner__message">
            <div class="epo-banner__body">
              <div class="epo-banner__title epo-banner__title--action">
                {{ $t('lbl_EMPBE_EPO_ActionBanner_Title', epoCopyParams) }}
              </div>
              <div class="epo-banner__text">
                {{ $t('lbl_EMPBE_EPO_ActionBanner_Body', epoCopyParams) }}
              </div>
              <div class="epo-banner__actions">
                <b-button
                  variant="primary"
                  class="epo-banner__btn"
                  :t_label="'EMPBE_EPO_MyUsers_ManageUsers_Action' + epoTrackSuffix"
                  @click="openSelectInactiveModal"
                >
                  {{ $t('lbl_EMPBE_EPO_ActionBanner_ManageUsers') }}
                </b-button>
                <button
                  type="button"
                  class="epo-banner__cta"
                  :t_label="'EMPBE_EPO_MyUsers_ContactSales_Action' + epoTrackSuffix"
                  @click="openContactUsModal"
                >
                  {{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Notify：T+7~T+21 蓝条；仍超员用待处理文案，已清除用无效页签文案 -->
        <div
          v-if="showEpoNotifyBanner"
          class="epo-banner epo-banner--notify"
        >
          <img
            class="epo-banner__plan-icon"
            :src="epoNotifyIconSrc"
            width="40"
            height="40"
            alt=""
          />
          <div class="epo-banner__message">
            <div class="epo-banner__body">
              <div class="epo-banner__title epo-banner__title--notify">
                <template v-if="epoNotifyStillOver">
                  {{ $t('lbl_EMPBE_EPO_NotifyBanner_StillOver_Title', epoCopyParams) }}
                </template>
                <template v-else>
                  {{ $t('lbl_EMPBE_EPO_NotifyBanner_Title', epoCopyParams) }}
                </template>
              </div>
              <div class="epo-banner__text">
                {{ epoNotifyStillOver
                  ? $t('lbl_EMPBE_EPO_NotifyBanner_StillOver_Body', epoCopyParams)
                  : $t('lbl_EMPBE_EPO_NotifyBanner_Body', epoCopyParams) }}
              </div>
              <div v-if="epoNotifyStillOver" class="epo-banner__actions">
                <b-button
                  variant="primary"
                  class="epo-banner__btn"
                  :t_label="'EMPBE_EPO_MyUsers_ManageUsers_Notify' + epoTrackSuffix"
                  @click="openSelectInactiveModal"
                >
                  {{ $t('lbl_EMPBE_EPO_ActionBanner_ManageUsers') }}
                </b-button>
                <button
                  type="button"
                  class="epo-banner__cta"
                  :t_label="'EMPBE_EPO_MyUsers_ContactSales_Notify' + epoTrackSuffix"
                  @click="openContactUsModal"
                >
                  {{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}
                </button>
              </div>
            </div>
            <button
              v-if="!epoNotifyStillOver"
              type="button"
              class="epo-banner__cta"
              :t_label="'EMPBE_EPO_MyUsers_ContactSales_Notify' + epoTrackSuffix"
              @click="openContactUsModal"
            >
              {{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}
            </button>
          </div>
        </div>

        <div class="User-MyUsers-ListPanel">
          <template v-if="displayedUserList.length">
            <div
              class="AccountCard"
              :class="{ 'AccountCard--inactive': userTab === 'inactive' }"
              v-for="(item, index) in displayedUserList"
              :key="(item?.accountUserId || index) + '-' + userTab"
            >
              <div class="AccountCard-Img">
                <img v-if="item?.userLogo" :src="item?.userLogo" />
                <div v-if="!item?.userLogo" class="AccountCard-Img-None">
                  <div class="AccountCard-Img-None-text"
                    v-html="DefaultCompanyfirstName(langid == 1252 ? item?.personNameEn : item?.personNameSc)">
                  </div>
                </div>
              </div>
              <div class="AccountCard-Info">
                <div class="AccountCard-Name">
                  <div class="AccountCard-Names">{{ langid == 1252 ? item?.personNameEn : item?.personNameSc
                  }}
                  </div>
                  <template v-if="userTab === 'active'">
                    <div class="AccountCard-Person" v-if="item?.IsContactPerson">{{ $t('EMP_UserSetting_ContactPerson') }}</div>
                    <div class="AccountCard-Representative" v-if="item?.isDisplayContactCard == 1">{{ $t('lbl_EMPBE_eBoothRepresentative') }}</div>
                  </template>
                  <div class="AccountCard-Member" :class="{ 'AccountCard-Member--inactive': userTab === 'inactive' }" v-if="item?.userRole">
                    ({{ GetUserRoleLabel(item?.userRole) }})
                  </div>
                </div>
                <div class="AccountCard-Job AccountCardInfoMsg">{{ langid == 1252 ? item?.jobTitleEn :
                  item?.jobTitleSc }}</div>
                <template v-if="userTab === 'active'">
                  <div class="AccountCard-Phone AccountCardInfoMsg" v-if="item?.phoneValue">{{ GetPhoneTitle(item)
                  }}<i
                      :class="`${item?.phoneIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'}`"></i>
                  </div>
                  <div class="AccountCard-Email AccountCardInfoMsg" v-if="item?.emailValue">{{ item?.emailValue
                  }}<i
                      :class="`${item?.emailIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'}`"></i>
                  </div>
                  <div class="AccountCard-Password AccountCardInfoMsg" v-if="item?.passwordValue">
                    {{ $t('lbl_emp2_Password') }}
                    <i :class="item?.passwordIsVerify ? 'UserSetting_IsVersion_Icon' : 'UserSetting_IsVersion_Icon_None'"></i>
                  </div>
                </template>
              </div>
              <div class="AccountCard-Edit">
                <b-button variant="outline-primary" v-bind:t_label="'EMP_UserSetting_Edit'"
                  @click="ShowDialogFunc(item?.accountUserId)">
                  {{ $t('EMP_UserSetting_Edit') }}
                </b-button>
              </div>
            </div>
          </template>
          <div v-else class="User-MyUsers-Empty" role="status">
            {{ userTab === 'inactive'
              ? $t('EMP_UserSetting_Empty_Inactive')
              : $t('EMP_UserSetting_Empty_Active') }}
          </div>
        </div>
      </div>
    </div>
    </b-overlay>
    <EpoRoleInactiveModal
      v-model="showSelectInactiveModal"
      :excess-count="epoNotice.excessCount"
      :target-role-limit="epoNotice.targetRoleLimit"
      @saved="onSelectInactiveSaved"
    />
    <RoleQuotaUpgradeModal
      v-model="showRoleQuotaUpgradeModal"
      :learn-more-url="roleQuotaUpgradeUrl"
      @contact-sales="openContactUsModal"
    />
    <UserSettingDialog
      v-model="Showdialog"
      :DilogTitle="DiaLogAccountUserId === 0 ? $t('EMP_UserSetting_AddUser') : $t('lbl_EMPBE_EditUser')"
      :AccountUserId="DiaLogAccountUserId"
      :companyId="companyId"
      @refresh="onUserDataChanged"
    >
    </UserSettingDialog>
    <UserSettingTips ref="UserSettingTipsRef" :type="ModalType" v-model="ShowModal" :captchaVerifyParam="captchaVerifyParam"
      :contactList="ContactList" @request-captcha="handleRequestCaptchaForRetrieve">
    </UserSettingTips>
    <GeetestCaptcha @captchaVerifyCallbackGeetest="finishSlideGeetest" ref="MyUsersCaptchaInstance"
      :currentUrlName="GetIsUatName" />
    <GeetestCaptcha @captchaVerifyCallbackGeetest="finishContactUsSlideGeetest" ref="ContactUsCaptchaInstance"
      :currentUrlName="GetIsUatName" />
    
    <!-- Contact Us 简化版抽屉（浮动在右边，隐藏按钮） -->
    <ContactUsDrawer
      :show="showContactUsModal"
      :form-data="contactUsForm"
      :reason-options="contactUsReasonOptions"
      :country-options="contactUsCountryOptions"
      :loading="contactUsLoading"
      :submitting="contactUsSubmitting"
      :hide-button="true"
      :simple="true"
      @update:formData="handleContactUsFormUpdate"
      @submit="handleContactUsSubmit"
      @close="closeContactUsModal"
    />
    
    <!-- ContactUs 成功提示弹框 -->
    <ContactUsSuccessModal
      :show="showContactUsSuccessModal"
      @close="closeContactUsSuccessModal"
    />
  </div>
</template>

<script>
import UserSettingDialog from './UserSettingDialog.vue';
import UserSettingTips from './UserSettingTips.vue';
import GeetestCaptcha from '../../components/GeetestCaptcha.vue';
import ContactUsDrawer from '../../components/new-login/ContactUs/ContactUsDrawer.vue';
import ContactUsSuccessModal from '../../components/new-login/ContactUs/ContactUsSuccessModal.vue';
import EpoRoleInactiveModal from '../../components/EpoRoleInactiveModal.vue';
import RoleQuotaUpgradeModal from '../../components/RoleQuotaUpgradeModal.vue';
import { userService, CompanyInfoService } from "../../_services";
import { epoService } from '../../_services/epo.service';
import { AlertDialog } from "../../_helpers/AlertDialog";
import { normalizeApiResponse } from '../../_helpers/apiResponse';
import { getContactUsConfig, DEFAULT_LANG_ID } from '../../components/new-login/Common/new-login-config.js';
import { detectLocationByIP } from '../../components/new-login/Common/ip-geolocation.js';
export default {
  mixins: [AlertDialog],
  components: {
    UserSettingDialog,
    UserSettingTips,
    GeetestCaptcha,
    ContactUsDrawer,
    ContactUsSuccessModal,
    EpoRoleInactiveModal,
    RoleQuotaUpgradeModal,
  },
  props: {
    companyId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    const currentLangId = parseInt(localStorage.getItem('currentLangId')) || DEFAULT_LANG_ID;
    const contactUsConfig = getContactUsConfig('supplier');
    
    return {
      cellCountryOptions: [],
      DiaLogAccountUserId: 0,
      ContactList: [],
      MyUserList: [],
      userTab: 'active',
      showSelectInactiveModal: false,
      showRoleQuotaUpgradeModal: false,
      epoNotice: {
        needNotice: false,
        phase: 'None',
        scheduledDate: '',
        actionDeadline: '',
        targetRoleLimit: 0,
        currentRoleLimit: 0,
        currentRoleUsed: 0,
        excessCount: 0,
        daysRemaining: 0,
        jobClearDays: 7,
        clearedCount: 0,
        hasSubmitted: false,
      },
      roleQuotaLimit: null,
      roleQuotaUsed: 0,
      roleQuotaRemaining: null,
      roleQuotaEBoothGrade: '',
      roleQuotaIsMember: false,
      CurrentUserAccount: null, // 存储当前用户的账户信息
      captchaVerifyParam: {},
      ShowModal: false,
      ModalType: 0,
      selectedContactItem: null, // 存储选中的联系方式项（用于找回密码）
      Showdialog: false,
      // Contact Us 相关数据
      showContactUsModal: false,
      showContactUsSuccessModal: false, // 是否显示 Contact Us 成功模态框
      contactUsLoading: false,
      contactUsSubmitting: false,
      loading: true,
      contactUsReasonOptions: [],
      contactUsCountryOptions: [],
      companyCountryOptions: [], // GetCountryList: { id, label }
      contactUsCaptchaData: null, // 存储验证码数据
      loginInfo: null, // 存储登录信息（通过 GetLoginInfo 获取）
      ipLocationInfo: null, // 存储 IP 地理位置信息
      companyInfo: null, // 存储公司详细信息
      contactUsReasonConfig: [
        { value: 1, text: '我需要协助,请联系我。', langid: 936 },
        { value: 1, text: '我需要協助,請聯繫我。', langid: 950 },
        { value: 1, text: 'I need assistance. Please contact me.', langid: 1252 },
        { value: 2, text: '我想更改主帐号的密码，请联系我。', langid: 936 },
        { value: 2, text: '我想更改主帳號的密碼，請聯繫我。', langid: 950 },
        { value: 2, text: 'I want to update the password of the master account. Please contact me.', langid: 1252 }
      ],
      contactUsForm: {
        fid: contactUsConfig.fid,
        hidCodepage: String(currentLangId),
        showid: contactUsConfig.showid,
        showcode: contactUsConfig.showcode,
        langid: currentLangId,
        Reason: 1,
        ReasonText: currentLangId === 936 ? '我需要协助,请联系我。' : (currentLangId === 950 ? '我需要協助,請聯繫我。' : 'I need assistance. Please contact me.'),
        message: '',
        name: '',
        Company: '',
        Country: '',
        CountryText: '',
        Mobile: '',
        Email: '',
        hdPrivacy: false,
        hdShare: true,
        captchaVerifyParam: '',
        submitPageURL: 'MyUsersContactUs',
        IsNewValidCode: 'true',
        isNotNeedValidate: 'false'
      }
    }
  },
  computed: {
    // 功能埋点后缀：_公司id_角色用户id（accountUserId）
    epoTrackSuffix() {
      const u = this.$store?.state?.authentication?.user || {};
      const companyId = u.empCompanyId || u.EmpCompanyId || 0;
      const roleUserId = u.accountUserId || u.AccountUserId || 0;
      return `_${companyId}_${roleUserId}`;
    },
    isSuperAdmin() {
      const currentUser = this.$store?.state?.authentication?.user;
      return currentUser?.IsFullAccess === true;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    GetIsUatName() {
      var isUatName = process.env.VUE_APP_EMP_ENV_NAME == "UAT" ? "eMarketplaceUat_Back" : "eMarketplace_Back";
      isUatName = process.env.VUE_APP_EMP_ENV_NAME == "AI" ? "eMarketplaceAi_Back" : isUatName;

      return isUatName;
    },
    isRoleQuotaFull() {
      if (this.roleQuotaLimit === null || this.roleQuotaLimit === undefined) return false;
      // 过渡期无限
      if (Number(this.roleQuotaLimit) < 0) return false;
      const remaining = this.roleQuotaRemaining;
      if (remaining !== null && remaining !== undefined) {
        if (Number(remaining) < 0) return false;
        return Number(remaining) <= 0;
      }
      return Number(this.roleQuotaUsed) >= Number(this.roleQuotaLimit);
    },
    resolvedEBoothGrade() {
      const fromQuota = this.roleQuotaEBoothGrade;
      const fromUser = this.$store?.state?.authentication?.user?.eBoothGrade
        ?? this.$store?.state?.authentication?.user?.EBoothGrade;
      return String(fromQuota || fromUser || '').trim().toUpperCase();
    },
    /** A+ 已是最高档：满额只提示，不引导升级 */
    isAPlusBooth() {
      const g = this.resolvedEBoothGrade;
      return g === 'A+' || g === 'APLUS';
    },
    /** 免费展台：F / Free / Guest；或空档且非 Basic 会员 */
    isFreeBooth() {
      const g = this.resolvedEBoothGrade;
      if (g === 'F' || g === 'FREE' || g === 'GUEST') return true;
      if (g === 'BASIC' || g === 'MEMBER' || g === 'A+' || g === 'APLUS' || g === 'A' || g === 'B' || g === 'C') {
        return false;
      }
      if (!g) {
        const u = this.$store?.state?.authentication?.user || {};
        const isMember = this.roleQuotaIsMember
          || u.IsMember === true || u.isMember === true || u.IsMember === 1;
        return !isMember;
      }
      return false;
    },
    /** 有效页签 + 名额已满 + 仅免费展台：升级横幅 */
    showRoleQuotaNoQuotaBanner() {
      return this.userTab === 'active' && this.isRoleQuotaFull && this.isFreeBooth;
    },
    /** 与销售线索 no-quota 升级条左侧图一致 */
    roleQuotaLockImg() {
      const base = process.env.BASE_URL || '/';
      return `${base}img/epo-saleslead-upgrade-graphic.svg`;
    },
    /** 与销售线索「了解更多」一致：会员级别及权益页 */
    roleQuotaUpgradeUrl() {
      const lang = localStorage.getItem('currentLang') || 'simp';
      const base = (process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace/').replace(/\/?$/, '/');
      return `${base}MembershipsAndBenefits/${lang}`;
    },
    activeUserList() {
      return (this.MyUserList || []).filter((u) => !this.isInactiveUser(u));
    },
    inactiveUserList() {
      return (this.MyUserList || []).filter((u) => this.isInactiveUser(u));
    },
    displayedUserList() {
      return this.userTab === 'inactive' ? this.inactiveUserList : this.activeUserList;
    },
    epoExpiryDateText() {
      return this.formatEpoDate(this.epoNotice.scheduledDate);
    },
    epoDeadlineText() {
      if (this.epoNotice.actionDeadline) {
        return this.formatEpoDate(this.epoNotice.actionDeadline);
      }
      const raw = this.epoNotice.scheduledDate;
      if (!raw) return '';
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return '';
      d.setDate(d.getDate() + 6);
      return this.formatEpoDate(d);
    },
    epoAutoDateText() {
      const raw = this.epoNotice.scheduledDate;
      if (!raw) return '';
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return '';
      d.setDate(d.getDate() + (Number(this.epoNotice.jobClearDays) || 7));
      return this.formatEpoDate(d);
    },
    epoCopyParams() {
      return {
        date: this.epoExpiryDateText,
        deadline: this.epoDeadlineText,
        autoDate: this.epoAutoDateText,
        old: this.epoNotice.currentRoleLimit,
        new: this.epoNotice.targetRoleLimit,
        count: this.epoNotice.currentRoleUsed,
        excess: this.epoNotice.excessCount,
        days: this.epoNotice.daysRemaining,
      };
    },
    epoRemindIconSrc() {
      return `${process.env.BASE_URL || '/'}img/epo-plan-changed-remind.svg`;
    },
    epoActionIconSrc() {
      return `${process.env.BASE_URL || '/'}img/epo-plan-changed-action.svg`;
    },
    epoNotifyIconSrc() {
      return `${process.env.BASE_URL || '/'}img/epo-plan-changed-notify.svg`;
    },
    /** 蓝条人数以当前无效列表为准，不用日志虚数 */
    epoNotifyUserCount() {
      const fromList = (this.inactiveUserList || []).length;
      if (fromList > 0) return fromList;
      return Number(this.epoNotice.clearedCount || 0);
    },
    /** 有效角色额度无限（过渡期 -1）时，角色下调条不出 */
    isRoleQuotaUnlimited() {
      return this.roleQuotaLimit !== null && Number(this.roleQuotaLimit) < 0;
    },
    /** 粉条仅 Action 窗；Notify 仍超员走蓝条文案 */
    showEpoActionBanner() {
      return (
        !this.isRoleQuotaUnlimited
        && this.userTab === 'active'
        && this.epoNotice.needNotice
        && this.epoNotice.phase === 'Action'
        && Number(this.epoNotice.excessCount || 0) > 0
      );
    },
    epoNotifyStillOver() {
      return (
        !this.isRoleQuotaUnlimited
        && this.epoNotice.phase === 'Notify'
        && Number(this.epoNotice.excessCount || 0) > 0
      );
    },
    /** 蓝条：Notify 且（仍超员 或 无效页签有人）；过渡无限不出角色条 */
    showEpoNotifyBanner() {
      if (this.isRoleQuotaUnlimited) return false;
      const inactiveLen = (this.inactiveUserList || []).length;
      return (
        this.epoNotice.phase === 'Notify'
        && this.epoNotice.needNotice
        && (this.epoNotifyStillOver || inactiveLen > 0)
      );
    },
    /* 黄条看「下一个套餐」，当前过渡无限仍可出预告 */
    showEpoReminderBanner() {
      return (
        this.userTab === 'active'
        && this.epoNotice.phase === 'Reminder'
        && this.epoNotice.needNotice
        && Number(this.epoNotice.excessCount || 0) > 0
      );
    },
    // 检查当前登录用户是否是 admin 或 root（主账户）
    isCurrentUserAdmin() {
      const currentUser = this.$store?.state?.authentication?.user;
      
      // 检查是否是 root（主账户）：如果用户不在 MyUserList 中，可能是主账户
      // 或者通过 IsFullAccess 来判断
      if (currentUser) {
        // 如果用户有 IsFullAccess 权限，说明是 root（主账户）
        if (currentUser.IsFullAccess === true) {
          return true;
        }
        
        // 如果用户不在 MyUserList 中，可能是主账户
        if (currentUser.accountUserId && Array.isArray(this.MyUserList) && this.MyUserList.length > 0) {
          const matched = this.MyUserList.find(
            user => String(user.accountUserId) === String(currentUser.accountUserId)
          );
          if (!matched) {
            // 用户不在列表中，可能是主账户
            return true;
          }
        }
      }
      
      // 1）优先使用 GetUserMyAccount 返回的当前账号信息
      if (this.CurrentUserAccount && this.CurrentUserAccount.userRole) {
        const role = String(this.CurrentUserAccount.userRole).toLowerCase();
        if (role === 'admin') {
          return true;
        }
      }

      // 2）再看登录态里的用户信息
      if (currentUser && currentUser.userRole) {
        const role = String(currentUser.userRole).toLowerCase();
        if (role === 'admin') {
          return true;
        }
      }

      // 3）兜底：如果登录态里有 accountUserId，就到 MyUserList 里匹配一条记录再判断角色
      if (currentUser && currentUser.accountUserId && Array.isArray(this.MyUserList) && this.MyUserList.length > 0) {
        const matched = this.MyUserList.find(
          user => String(user.accountUserId) === String(currentUser.accountUserId)
        );
        if (matched && matched.userRole) {
          const role = String(matched.userRole).toLowerCase();
          if (role === 'admin') {
            return true;
          }
        }
      }

      return false;
    },
    // 检查系统中是否存在admin用户
    hasAdminUser() {
      // 方法1：检查 MyUserList 中是否有 admin 用户
      if (this.MyUserList && this.MyUserList.length > 0) {
        const hasAdmin = this.MyUserList.some(user => {
          const userRole = String(user.userRole || '').toLowerCase();
          return userRole === 'admin';
        });
        if (hasAdmin) {
          return true;
        }
      }
      
      // 方法2：检查 ContactList 中是否有 admin 用户的联系方式（更可靠，因为 ContactList 已经被过滤为只包含 admin）
      if (this.ContactList && this.ContactList.length > 0) {
        return true;
      }
      
      return false;
    },
    // 将 MasterAccountTip 中的 "contact us" 转换为可点击链接
    masterAccountTipWithLink() {
      const tip = this.$t('EMP_UserSetting_MasterAccountTip');
      // 替换 "contact us" 为可点击链接
      return tip.replace(/(contact us|联系我们|聯繫我們)/i, '<a href="#" class="contact-us-link">$1</a>');
    },
    // 检查用户是否已登录
    isLoggedIn() {
      const user = this.$store?.state?.authentication?.user;
      return !!user;
    }
  },
  watch: {
    Showdialog() {
      // 关闭弹窗只刷列表；删除/停用成功走 @refresh → onUserDataChanged（含横幅）
      if (!this.Showdialog) {
        this.GetUserMyUserFunc();
      }
    },
    ShowModal(newVal) {
      // 当弹窗关闭时，清空选中的联系方式项和验证码参数
      if (!newVal) {
        this.selectedContactItem = null;
        this.captchaVerifyParam = {};
      }
    },
    companyId: {
      handler(newVal, oldVal) {
        if (oldVal !== undefined) {
          this.onUserDataChanged();
        }
      },
      immediate: false
    }
  },
  mounted() {
    if (this.companyId || !this.companyId) {
      this.GetUserMyUserFunc();
    }
    this.getCellCountryOptions();
    this.GetCurrentUserAccount();
    this.GetLoginInfo(); // 获取登录信息（邮箱、手机号等）
    this.detectIPLocation(); // 检测 IP 地理位置
    this.GetCompanyInfo(); // 获取公司信息
    this.loadContactUsReasons();
    this.loadEpoNotice();
  },
  methods:
  {
    isInactiveUser(user) {
      const v = user?.isDisable ?? user?.IsDisable;
      return v === true || v === 1 || v === '1';
    },
    formatEpoDate(raw) {
      if (!raw) return '';
      const d = raw instanceof Date ? raw : new Date(raw);
      if (Number.isNaN(d.getTime())) return String(raw);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      return `${d.getFullYear()}-${mm}-${dd}`;
    },
    emptyEpoNotice() {
      return {
        needNotice: false,
        phase: 'None',
        scheduledDate: '',
        actionDeadline: '',
        targetRoleLimit: 0,
        currentRoleLimit: 0,
        currentRoleUsed: 0,
        excessCount: 0,
        daysRemaining: 0,
        jobClearDays: 7,
        clearedCount: 0,
        hasSubmitted: false,
      };
    },
    async loadEpoNotice() {
      const user = this.$store?.state?.authentication?.user;
      if (!user || String(user.userType || '').toUpperCase() === 'ADMIN') return;
      try {
        const res = normalizeApiResponse(await epoService.GetRoleInactiveNotice());
        if (!res?.isSuccessful) return;
        const row = Array.isArray(res.data) ? res.data[0] : res.data;
        if (!row) {
          this.epoNotice = this.emptyEpoNotice();
          return;
        }
        this.epoNotice = {
          needNotice: !!(row.needNotice ?? row.NeedNotice),
          phase: String(row.phase ?? row.Phase ?? 'None'),
          scheduledDate: row.scheduledDate ?? row.ScheduledDate ?? '',
          actionDeadline: row.actionDeadline ?? row.ActionDeadline ?? '',
          targetRoleLimit: Number(row.targetRoleLimit ?? row.TargetRoleLimit ?? 0),
          currentRoleLimit: Number(row.currentRoleLimit ?? row.CurrentRoleLimit ?? 0),
          currentRoleUsed: Number(row.currentRoleUsed ?? row.CurrentRoleUsed ?? 0),
          excessCount: Number(row.excessCount ?? row.ExcessCount ?? 0),
          daysRemaining: Number(row.daysRemaining ?? row.DaysRemaining ?? 0),
          jobClearDays: Number(row.jobClearDays ?? row.JobClearDays ?? 7) || 7,
          clearedCount: Number(row.clearedCount ?? row.ClearedCount ?? 0),
          hasSubmitted: !!(row.hasSubmitted ?? row.HasSubmitted),
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('GetRoleInactiveNotice failed:', e);
      }
    },
    openSelectInactiveModal() {
      this.showSelectInactiveModal = true;
    },
    /** 删除/停用/编辑保存成功：刷用户列表 + EPO 提醒横幅（对齐 productlisting #91） */
    async onUserDataChanged() {
      await this.GetUserMyUserFunc();
      await this.loadEpoNotice();
    },
    async onSelectInactiveSaved() {
      await this.onUserDataChanged();
    },
    GetPhoneTitle(item) {
      var PhonePrefix = this.cellCountryOptions.find(a => a.id == item.phoneCountry)?.label;
      return PhonePrefix + " " + item.phoneValue
    },
    async getCellCountryOptions() {
      this.cellCountryOptions = (await CompanyInfoService.GetCellCountryData()).map(item => {
        return {
          id: item.Code,
          label: '+' + item.Option
        }
      });
    },
    async GetUserMyUserFunc() {
      this.loading = true;
      try {
        const currentUser = this.$store?.state?.authentication?.user;
        const isSuperAdmin = currentUser?.IsFullAccess === true;
        
        let res;
        if (isSuperAdmin && this.companyId) {
          res = await userService.GetUserMyUserByAdministrator({
            accountId: Number(this.companyId),
            accountUserId: -1
          });
        } else {
          res = await userService.GetUserMyUser();
        }
        
        const myUserList = res.data.myUserList
          .map((item) => {
            // 优先使用后端返回的 isDisplayContactCard（唯一代表标识）
            // 如果不存在，则使用 displayContactCard（用户自己的设置值）
            let isDisplayContactCard = 0;
            
            if (item.isDisplayContactCard !== undefined && item.isDisplayContactCard !== null) {
              isDisplayContactCard = (item.isDisplayContactCard == '1' || item.isDisplayContactCard === 1 || item.isDisplayContactCard === true) ? 1 : 0;
            } else if (item.displayContactCard !== undefined && item.displayContactCard !== null) {
              isDisplayContactCard = (item.displayContactCard == '1' || item.displayContactCard === 1 || item.displayContactCard === true) ? 1 : 0;
            }
            const rawDisable = item?.isDisable ?? item?.IsDisable;
            const isDisable = rawDisable === true || rawDisable === 1 || rawDisable === '1';
            if (isDisable) {
              isDisplayContactCard = 0;
            }
            
            const IsContactPerson =
              !isDisable
              && (
                item.notifySystem == '1'
                || item.notifySourcing == '1'
                || item.notifyEnquiry == '1'
                || item.notifyAds == '1'
                || item.notifyNameCard == '1'
              )
                ? true
                : false;
            
            return {
              ...item,
              isDisable,
              IsContactPerson: IsContactPerson,
              isDisplayContactCard: isDisplayContactCard,
            };
          });
        
        // 为 contactList 中的 Phone 类型添加 phoneCountry 信息，并过滤出只有 admin 用户的联系方式
        this.ContactList = res.data.contactList
          .map(contactItem => {
            // 根据 loginType 和 value 从 myUserList 中查找匹配的用户
            let matchedUser = null;
            if (contactItem.loginType === 'Phone') {
              matchedUser = myUserList.find(user => user.phoneValue === contactItem.value);
              if (matchedUser && matchedUser.phoneCountry) {
                return {
                  ...contactItem,
                  phoneCountry: matchedUser.phoneCountry,
                  userRole: matchedUser.userRole // 添加 userRole 信息
                };
              }
            } else if (contactItem.loginType === 'Email') {
              matchedUser = myUserList.find(user => user.emailValue === contactItem.value);
              if (matchedUser) {
                return {
                  ...contactItem,
                  userRole: matchedUser.userRole // 添加 userRole 信息
                };
              }
            }
            return {
              ...contactItem,
              userRole: matchedUser?.userRole || null
            };
          })
          .filter(contactItem => {
            // 只保留 admin 用户的联系方式
            const userRole = String(contactItem.userRole || '').toLowerCase();
            return userRole === 'admin';
          });
        
        this.MyUserList = myUserList;

        const quotaRaw = res.data.roleQuota || res.data.RoleQuota || null;
        const quota = Array.isArray(quotaRaw) ? quotaRaw[0] : quotaRaw;
        if (quota) {
          this.roleQuotaLimit = Number(quota.roleQuotaLimit ?? quota.RoleQuotaLimit ?? 0);
          this.roleQuotaUsed = Number(quota.roleQuotaUsed ?? quota.RoleQuotaUsed ?? 0);
          this.roleQuotaRemaining = Number(quota.roleQuotaRemaining ?? quota.RoleQuotaRemaining ?? 0);
          this.roleQuotaEBoothGrade = String(quota.eBoothGrade ?? quota.EBoothGrade ?? '').trim();
          const im = quota.isMember ?? quota.IsMember;
          this.roleQuotaIsMember = im === true || im === 1 || im === '1';
        } else {
          this.roleQuotaLimit = null;
          this.roleQuotaUsed = 0;
          this.roleQuotaRemaining = null;
          this.roleQuotaEBoothGrade = '';
          this.roleQuotaIsMember = false;
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    // 获取当前用户的账户信息
    async GetCurrentUserAccount() {
      try {
        const res = await userService.GetUserMyAccount();
        if (res && res.data) {
          this.CurrentUserAccount = res.data;
        }
      } catch (error) {
        // Error handled silently
      }
    },
    // 获取登录信息（邮箱、手机号等）
    async GetLoginInfo() {
      try {
        const res = await userService.GetLoginInfo();
        if (res && Array.isArray(res)) {
          this.loginInfo = res;
          
          // 自动填充到表单（如果表单已打开）
          if (this.showContactUsModal) {
            this.fillUserInfoToForm();
          }
        }
      } catch (error) {
        // Error handled silently
      }
    },
    // 检测 IP 地理位置
    async detectIPLocation() {
      try {
        const locationInfo = await detectLocationByIP();
        if (locationInfo) {
          this.ipLocationInfo = locationInfo;
        }
      } catch (error) {
        // Error handled silently
      }
    },
    // 获取公司信息
    async GetCompanyInfo() {
      try {
        const user = this.$store?.state?.authentication?.user;
        if (user && user.empCompanyId) {
          const res = await CompanyInfoService.GetCompanyInfoAsync({ companyId: user.empCompanyId });
          if (res && res.isSuccessful && res.data) {
            this.companyInfo = res.data;
            
            // 如果表单已打开，更新表单数据
            if (this.showContactUsModal) {
              this.$nextTick(() => {
                this.fillUserInfoToForm();
              });
            }
          }
        }
      } catch (error) {
        // Error handled silently
      }
    },
    GetUserRoleLabel(userRole) {
      if (!userRole) return '';
      const roleLower = String(userRole).toLowerCase();
      if (roleLower === 'admin') {
        return this.$t('EMP_UserSetting_Role_Admin');
      } else if (roleLower === 'member') {
        return this.$t('EMP_UserSetting_Role_Member');
      }
      return userRole;
    },
    DefaultCompanyfirstName(Name) {
      // 检查Name是否存在且为字符串
      if (!Name || typeof Name !== 'string') {
        return "";
      }

      // 安全地调用replaceEmTag方法（如果存在）
      let processedName = Name;
      if (typeof Name.replaceEmTag === 'function') {
        processedName = Name.replaceEmTag();
      }

      // 移除非中文、英文字母和数字的字符
      const cleanedName = processedName.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');

      // 返回第一个字符，如果是英文字母则转换为大写
      if (cleanedName.length > 0) {
        const firstChar = cleanedName[0];
        // 如果是英文字母，转换为大写
        if (/[a-zA-Z]/.test(firstChar)) {
          return firstChar.toUpperCase();
        }
        return firstChar;
      }
      return "";
    },
    RetrieveFunc() {
      // 只检查用户列表中是否存在admin用户
      if (!this.hasAdminUser) {
        // 按设计显示提示弹框：标题 + 内容 + OK（多语言）
        const title = this.$t('EMP_UserSetting_PleaseAddAdminFirst');
        const content = this.$t('EMP_UserSetting_CannotRetrieveWithoutAdmin');
        // 第二个参数支持 HTML，第三个参数为 true 表示内容包含 HTML
        this.showSubmitSucess(title,content);
        return;
      }
      
      // 如果检查通过，直接显示联系方式列表（不显示验证码）
      this.captchaVerifyParam = {}; // 清空之前的验证码参数
      this.selectedContactItem = null; // 清空之前选中的项
      this.ModalType = 3;
      this.ShowModal = true;
    },
    ShowDialogFunc(accountUserId) {
      // 新增且名额已满：A+ → 仅提示；其它档 → 升级弹窗
      if (accountUserId === 0 && this.isRoleQuotaFull) {
        if (this.isAPlusBooth) {
          this.showSubmitSucess(
            this.$t('EMP_UserSetting_RoleQuotaFullTitle_APlus'),
            this.$t('EMP_UserSetting_RoleQuotaFull_APlus')
          );
          return;
        }
        this.showRoleQuotaUpgradeModal = true;
        return;
      }
      this.DiaLogAccountUserId = accountUserId;
      this.Showdialog = true;
    },
    //滑块完成后的回调事件
    finishSlideGeetest(captchaVerifyParam, resolve) {
      this.$nextTick(() => {
        this.captchaVerifyParam = captchaVerifyParam;
        
        // 如果是在找回密码流程中（有选中的联系方式项），直接发送
        if (this.selectedContactItem && this.ModalType === 3) {
          // 等待一个额外的 tick，确保 captchaVerifyParam 已经传递到子组件
          this.$nextTick(() => {
            // 通过 $refs 调用 UserSettingTips 组件的 RetrievePassword 方法
            if (this.$refs.UserSettingTipsRef) {
              this.$refs.UserSettingTipsRef.RetrievePassword(this.selectedContactItem);
            }
          });
        } else {
          // 其他场景保持原有逻辑
          this.ModalType = 3;
          this.ShowModal = true;
        }
        
        if (resolve) {
          resolve();
        }
      });
    },
    // 处理从 UserSettingTips 传来的请求验证码事件
    handleRequestCaptchaForRetrieve(contactItem) {
      // 保存选中的联系方式项
      this.selectedContactItem = contactItem;
      // 显示验证码
      if (this.$refs.MyUsersCaptchaInstance) {
        this.$refs.MyUsersCaptchaInstance.showGeetest();
      }
    },
    // ==================== Contact Us 相关方法 ====================
    /**
     * 处理提示文本容器的点击事件（用于委托处理链接点击）
     */
    handleTipContainerClick(event) {
      if (event.target && event.target.classList.contains('contact-us-link')) {
        event.preventDefault();
        this.openContactUsModal();
      }
    },
    /**
     * 打开 Contact Us 模态框
     */
    async openContactUsModal() {
      this.showContactUsModal = true;
      if (this.contactUsReasonOptions.length === 0) {
        this.loadContactUsReasons();
      }
      if (!this.contactUsForm.Reason || this.contactUsForm.Reason === null) {
        const currentLangId = this.contactUsForm.langid || parseInt(localStorage.getItem('currentLangId')) || 1252;
        this.contactUsForm.Reason = 1;
        this.contactUsForm.ReasonText = currentLangId === 936 ? '我需要协助,请联系我。' : (currentLangId === 950 ? '我需要協助,請聯繫我。' : 'I need assistance. Please contact me.');
      }
      
      // 如果还没有登录信息，先获取
      if (!this.loginInfo) {
        await this.GetLoginInfo();
      }
      
      // 如果还没有当前用户账户信息，先获取
      if (!this.CurrentUserAccount) {
        await this.GetCurrentUserAccount();
      }
      if (!this.companyInfo) {
        await this.GetCompanyInfo();
      }
      if (!this.companyCountryOptions.length) {
        await this.loadCompanyCountryOptions();
      }

      await this.fillUserInfoToForm();
    },
    /**
     * 自动填充当前登录用户信息到表单
     */
    async fillUserInfoToForm() {
      const currentLangId = parseInt(this.contactUsForm.langid || localStorage.getItem('currentLangId') || 1252);
      
      // 获取完整的用户信息
      const userInfo = this.getCompleteUserInfo();

      // 仅 MyUsers「联系我们」：Master / 个人帐号自动填入通知邮件字段
      const user = this.$store?.state?.authentication?.user || {};
      let role = String(user.userRole || '').toUpperCase();
      let accountUserId = user.accountUserId ?? user.AccountUserId;
      if (user.token && !String(user.token).startsWith('test-token-')) {
        try {
          const payload = JSON.parse(atob(String(user.token).split('.')[1]));
          if (!role) role = String(payload.userRole || '').toUpperCase();
          if (accountUserId === undefined || accountUserId === null) {
            accountUserId = payload.accountUserId;
          }
        } catch (e) { /* ignore */ }
      }

      // Master：Email/Mobile/Country = 说明文案；Name = CPXXXXX
      if (role === 'ROOT' || Number(accountUserId) === 0) {
        const note = this.$t('EMP_UserSetting_ContactUs_MasterLoginNote');
        this.contactUsForm.Email = note;
        this.contactUsForm.Mobile = note;
        this.contactUsForm.Country = note;
        this.contactUsForm.CountryText = note;
        this.contactUsForm.name = user.login || user.Login || '';
        return;
      }

      // 个人帐号：填 Name / Email / Mobile / Country（CountryText 供邮件模板）
      if (!userInfo || Object.keys(userInfo).length === 0) return;

      if (!this.contactUsForm.name) {
        const name = this.getUserField(userInfo, 'name', currentLangId);
        if (name) this.contactUsForm.name = name;
      }
      if (!this.contactUsForm.Email) {
        const email = this.getUserField(userInfo, 'email', currentLangId);
        if (email) this.contactUsForm.Email = email;
      }
      if (!this.contactUsForm.Company) {
        const company = this.getUserField(userInfo, 'company', currentLangId);
        if (company) this.contactUsForm.Company = company;
      }
      if (!this.contactUsForm.Mobile) {
        const mobile = this.getUserField(userInfo, 'mobile', currentLangId);
        if (mobile) this.contactUsForm.Mobile = mobile;
      }
      // Country：登录 countryId 常为 0（无效），需用公司 CountryId 映射国家名
      if (!this.contactUsForm.CountryText) {
        const countryName = this.resolveContactUsCountryName(userInfo);
        if (countryName) {
          this.contactUsForm.Country = countryName;
          this.contactUsForm.CountryText = countryName;
        }
      }
    },
    /** 解析个人帐号 Country 显示名：优先公司 CountryId，忽略登录里的 0 */
    resolveContactUsCountryName(userInfo) {
      const emp = (this.companyInfo && (this.companyInfo.companyEmp || this.companyInfo.CompanyEmp)) || {};
      const candidates = [
        emp.countryId, emp.CountryId,
        userInfo && userInfo.countryId, userInfo && userInfo.CountryId,
        this.$store?.state?.authentication?.user?.countryId
      ];
      const countryId = candidates.find(id => id !== undefined && id !== null && String(id) !== '' && Number(id) !== 0);
      if (!countryId || !this.companyCountryOptions.length) return '';
      const hit = this.companyCountryOptions.find(c => String(c.id) === String(countryId));
      return hit && hit.label ? hit.label : '';
    },
    async loadCompanyCountryOptions() {
      try {
        const res = await CompanyInfoService.GetCountryList();
        if (res && res.isSuccessful && Array.isArray(res.data)) {
          this.companyCountryOptions = res.data;
        }
      } catch (e) {
        this.companyCountryOptions = [];
      }
    },
    /**
     * 从用户信息中获取指定字段的值（根据语言选择）
     * @param {Object} userInfo - 用户信息对象
     * @param {string} field - 字段名：'name', 'company', 'email', 'mobile', 'country'
     * @param {number} langId - 语言ID
     * @returns {string} 字段值
     */
    getUserField(userInfo, field, langId) {
      if (!userInfo) return '';
      
      switch (field) {
        case 'name':
          // 尝试多种字段名
          if (langId === 1252 && userInfo.personNameEn) return userInfo.personNameEn;
          if (langId === 950 && userInfo.personNameTc) return userInfo.personNameTc;
          if (langId === 936 && userInfo.personNameSc) return userInfo.personNameSc;
          return userInfo.personNameEn || userInfo.personNameTc || userInfo.personNameSc 
            || userInfo.personName || userInfo.name || '';
        
        case 'company':
          if (langId === 1252 && userInfo.companyNameEn) return userInfo.companyNameEn;
          if (langId === 950 && userInfo.companyNameTc) return userInfo.companyNameTc;
          if (langId === 936 && userInfo.companyNameSc) return userInfo.companyNameSc;
          return userInfo.companyNameEn || userInfo.companyNameTc || userInfo.companyNameSc 
            || userInfo.companyName || userInfo.company || '';
        
        case 'email':
          return userInfo.emailValue || userInfo.email || userInfo.emailAddress || '';
        
        case 'mobile':
          return userInfo.phoneValue || userInfo.mobile || userInfo.mobileNumber 
            || userInfo.phone || userInfo.phoneNumber || '';
        
        case 'country':
          return userInfo.countryCode || userInfo.country || userInfo.countryId || '';
        
        case 'countryText':
          return '';
        
        default:
          return '';
      }
    },
    /**
     * 获取完整的用户信息（从多个来源）
     * @returns {Object} 合并后的用户信息对象
     */
    getCompleteUserInfo() {
      // 优先使用 CurrentUserAccount（从 GetUserMyAccount 获取，最完整）
      let userInfo = this.CurrentUserAccount ? { ...this.CurrentUserAccount } : {};
      
      // 如果没有，使用 store 中的用户信息
      const storeUser = this.$store?.state?.authentication?.user;
      if (storeUser) {
        // 合并 store 中的用户信息
        userInfo = { ...userInfo, ...storeUser };
      }
      
      // 如果还是没有，尝试从 MyUserList 中查找当前用户
      if (!userInfo.accountUserId && this.MyUserList && this.MyUserList.length > 0) {
        const currentUser = this.$store?.state?.authentication?.user;
        if (currentUser && currentUser.accountUserId) {
          const matchedUser = this.MyUserList.find(
            user => String(user.accountUserId) === String(currentUser.accountUserId)
          );
          if (matchedUser) {
            userInfo = { ...userInfo, ...matchedUser };
          }
        }
      }
      
      // 合并登录信息（从 GetLoginInfo 获取的邮箱、手机号等）
      if (this.loginInfo && Array.isArray(this.loginInfo)) {
        // 从 loginInfo 中提取邮箱和手机号
        this.loginInfo.forEach(item => {
          if (item.type === 'email' && item.verifyLogin) {
            userInfo.emailValue = item.verifyLogin;
            userInfo.email = item.verifyLogin;
          } else if (item.type === 'mobile' && item.verifyLogin) {
            userInfo.phoneValue = item.verifyLogin;
            userInfo.mobile = item.verifyLogin;
          }
        });
      }
      
      // 合并公司信息（从 GetCompanyInfo 获取）
      if (this.companyInfo) {
        const companyEmp = this.companyInfo.companyEmp || this.companyInfo.CompanyEmp || {};
        userInfo.companyNameEn = userInfo.companyNameEn || companyEmp.nameEng || companyEmp.NameEng || companyEmp.nameE || this.companyInfo.companyNameEn;
        userInfo.companyNameTc = userInfo.companyNameTc || companyEmp.nameTrad || companyEmp.NameTrad || companyEmp.nameT || this.companyInfo.companyNameTc;
        userInfo.companyNameSc = userInfo.companyNameSc || companyEmp.nameSimp || companyEmp.NameSimp || companyEmp.nameS || this.companyInfo.companyNameSc;
        // 登录返回的 countryId 常为 0，不能挡住公司 CountryId
        const loginCountryId = userInfo.countryId || userInfo.CountryId;
        const companyCountryId = companyEmp.countryId || companyEmp.CountryId || this.companyInfo.countryId;
        userInfo.countryId = (loginCountryId && Number(loginCountryId) !== 0)
          ? loginCountryId
          : companyCountryId;
        userInfo.country = userInfo.country || companyEmp.country || this.companyInfo.country;
        userInfo.countryCode = userInfo.countryCode || companyEmp.countryCode || this.companyInfo.countryCode;
      }
      
      // 合并 IP 地理位置信息（如果没有国家信息）
      if (this.ipLocationInfo && !userInfo.country && !userInfo.countryCode) {
        userInfo.ipCountry = this.ipLocationInfo.country;
        userInfo.ipCountryCode = this.ipLocationInfo.countryCode;
        if (!userInfo.country) {
          userInfo.country = this.ipLocationInfo.country;
        }
        if (!userInfo.countryCode) {
          userInfo.countryCode = this.ipLocationInfo.countryCode;
        }
      }
      
      return userInfo;
    },
    /**
     * 关闭 Contact Us 模态框
     */
    closeContactUsModal() {
      this.showContactUsModal = false;
    },
    /**
     * 关闭 Contact Us 成功模态框
     */
    closeContactUsSuccessModal() {
      this.showContactUsSuccessModal = false;
    },
    /**
     * 加载 Contact Us 查询原因下拉
     */
    loadContactUsReasons() {
      const currentLangId = this.contactUsForm.langid || parseInt(localStorage.getItem('currentLangId')) || 1252;
      this.contactUsReasonOptions = this.contactUsReasonConfig.filter(item => item.langid === currentLangId);
    },
    /**
     * 处理 ContactUs 表单数据更新
     */
    handleContactUsFormUpdate(newFormData) {
      this.contactUsForm = { ...this.contactUsForm, ...newFormData };
      if (newFormData.Reason !== undefined) {
        const selected = this.contactUsReasonOptions.find(r => r.value === newFormData.Reason);
        this.contactUsForm.ReasonText = selected ? selected.text : '';
      }
    },
    async handleContactUsSubmit() {
      const form = document.getElementById('cu-form-contact-us');
      if (!form) {
        this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: 'Form not found' }));
        return;
      }
      
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      
      await this.fillUserInfoToForm();
      
      this.contactUsSubmitting = true;
      this.contactUsLoading = true;
      
      await this.$nextTick();
      await this.doSubmitContactUs();
    },
    showContactUsCaptcha() {
      if (this.$refs.ContactUsCaptchaInstance) {
        this.$refs.ContactUsCaptchaInstance.showGeetest();
      }
    },
    async finishContactUsSlideGeetest(captchaVerifyParam, resolve) {
      this.$nextTick(async () => {
        // 设置本地状态
        this.contactUsCaptchaData = captchaVerifyParam;
        this.contactUsForm.captchaVerifyParam = JSON.stringify(captchaVerifyParam);
        
        // 更新隐藏字段（为了向后兼容，保留 DOM 操作）
        if (captchaVerifyParam) {
          const lotNumberInput = document.getElementById('cu-lot-number');
          const captchaOutputInput = document.getElementById('cu-captcha-output');
          const passTokenInput = document.getElementById('cu-pass-token');
          const genTimeInput = document.getElementById('cu-gen-time');
          const typeNameInput = document.getElementById('cu-type-name');
          
          if (lotNumberInput) lotNumberInput.value = captchaVerifyParam.lot_number || '';
          if (captchaOutputInput) captchaOutputInput.value = captchaVerifyParam.captcha_output || '';
          if (passTokenInput) passTokenInput.value = captchaVerifyParam.pass_token || '';
          if (genTimeInput) genTimeInput.value = captchaVerifyParam.gen_time || '';
          if (typeNameInput) typeNameInput.value = 'CPS_Login'; // 设置 typename
        }
        
        // 调用 resolve
        if (resolve) {
          resolve(true);
        }
        
        // 执行实际提交
        await this.doSubmitContactUs();
      });
    },
    /**
     * 执行实际提交
     */
    async doSubmitContactUs() {
      try {
        const form = document.getElementById('cu-form-contact-us');
        if (!form) {
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: 'Form not found' }));
          this.contactUsSubmitting = false;
          this.contactUsLoading = false;
          return;
        }

        const captchaData = null;
        
        const captchaTicketInput = document.getElementById('cu-captcha-ticket');
        const captchaRandstrInput = document.getElementById('cu-captcha-randstr');
        
        const { 
          sendFormEmail, 
          getEmailProjectByReason,
          getEmailConfigFromDatabase 
        } = await import('../../components/new-login/Common/email-sender.js');
        const { 
          SUBMIT_STATUS_CODE,
          DEFAULT_SHOW_ID,
          DEFAULT_SHOW_CODE,
          getCurrentLangId
        } = await import('../../components/new-login/Common/new-login-config.js');
        
        const reason = this.contactUsForm.Reason;
        const emailProject = getEmailProjectByReason(reason);
        const showId = this.contactUsForm.showid || DEFAULT_SHOW_ID;
        const langId = this.contactUsForm.langid || getCurrentLangId();
        const showCode = this.contactUsForm.showcode || DEFAULT_SHOW_CODE;
        const dbEmailConfig = await getEmailConfigFromDatabase(showId, langId, emailProject, showCode);
        const currentLangId = parseInt(langId);
        if (!this.companyInfo) {
          await this.GetCompanyInfo();
        }
        if (!this.companyCountryOptions.length) {
          await this.loadCompanyCountryOptions();
        }
        const userInfo = this.getCompleteUserInfo();
        
        await this.fillUserInfoToForm();
        const formDataToSend = {
          fid: this.contactUsForm.fid || '',
          showid: showId,
          showcode: showCode,
          langid: langId,
          hidCodepage: this.contactUsForm.hidCodepage || String(langId) || '1252',
          submitPageURL: this.contactUsForm.submitPageURL || 'MyUsersContactUs',
          IsNewValidCode: this.contactUsForm.IsNewValidCode || 'true',
          isNotNeedValidate: this.isLoggedIn ? 'true' : (this.contactUsForm.isNotNeedValidate || 'false'),
          captchaVerifyParam: typeof this.contactUsForm.captchaVerifyParam === 'string' 
            ? this.contactUsForm.captchaVerifyParam 
            : (this.contactUsForm.captchaVerifyParam ? JSON.stringify(this.contactUsForm.captchaVerifyParam) : ''),
          // Contact Us 表单字段 - 如果为空则使用用户信息填充
          Reason: reason,
          ReasonText: this.contactUsForm.ReasonText || '',
          message: this.contactUsForm.message || '',
          name: this.contactUsForm.name || this.getUserField(userInfo, 'name', currentLangId) || '',
          Company: this.contactUsForm.Company || this.getUserField(userInfo, 'company', currentLangId) || '',
          Country: this.contactUsForm.Country || '',
          CountryText: this.contactUsForm.CountryText || this.contactUsForm.Country || '',
          Mobile: this.contactUsForm.Mobile || this.getUserField(userInfo, 'mobile', currentLangId) || '',
          Email: this.contactUsForm.Email || this.getUserField(userInfo, 'email', currentLangId) || '',
          hdPrivacy: this.contactUsForm.hdPrivacy ? 'true' : 'false',
          hdShare: this.contactUsForm.hdShare ? 'true' : 'false',
          captcha_ticket: captchaTicketInput ? captchaTicketInput.value : '',
          captcha_randstr: captchaRandstrInput ? captchaRandstrInput.value : ''
        };
        const emailConfig = {
          email_to: this.contactUsForm.Email || '', // 用户邮箱 - 发送确认邮件
          email_from: dbEmailConfig.FromEmail || 'emarketplace@adsale.com.hk',
          email_fromName: dbEmailConfig.FromName || '',
          email_replyTo: dbEmailConfig.ReplyTo || '',
          email_bcc: dbEmailConfig.BCC || '',
          email_cc: dbEmailConfig.CC || '',
          email_subject: dbEmailConfig.Title || 'eMarketplace - Contact Us',
          email_confirm_message: 'Send form Success'
        };

        // 发送表单
        const result = await sendFormEmail({
          formData: formDataToSend,
          captchaData: captchaData,
          emailConfig: emailConfig,
          formType: 'contact-us'
        });

        if (result && result.statusCode === SUBMIT_STATUS_CODE.SUCCESS) {
          this.contactUsLoading = false;
          this.contactUsSubmitting = false;
          this.closeContactUsModal();
          this.showContactUsSuccessModal = true;
          this.resetContactUsForm();
        } else if (result && result.statusCode === SUBMIT_STATUS_CODE.CAPTCHA_FAILED) {
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: '验证码验证失败，请重试' }));
        } else if (result && result.statusCode === SUBMIT_STATUS_CODE.VALIDATION_ERROR) {
          const msg = result.Msg && result.Msg.length > 0 ? result.Msg.join(', ') : '数据验证失败';
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: `以下数据不能为空: ${msg}` }));
        } else {
          const errorMsg = result?.Msg ? (Array.isArray(result.Msg) ? result.Msg.join(', ') : result.Msg) : (result?.error || 'Unknown error');
          this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: errorMsg }));
        }
      } catch (error) {
        // Error handled by alert message
        this.$Alert(0, this.$t('lbl_EMPBE_Save_Failed_HasError', { msg: error.message || 'Submit failed' }));
      } finally {
        this.contactUsSubmitting = false;
        this.contactUsLoading = false;
      }
    },
    /**
     * 重置 Contact Us 表单
     */
    resetContactUsForm() {
      const currentLangId = this.contactUsForm.langid || parseInt(localStorage.getItem('currentLangId')) || 1252;
      this.contactUsForm = {
        ...this.contactUsForm,
        Reason: 1,
        ReasonText: currentLangId === 936 ? '我需要协助,请联系我。' : (currentLangId === 950 ? '我需要協助,請聯繫我。' : 'I need assistance. Please contact me.'),
        message: ''
      };
    }
  },
};
</script>
<style lang="scss" scoped>
.User-MyUsers {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .AccountCard-Img-None {
    width: 78px;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    background: linear-gradient(0deg, rgba(115, 102, 255, 0.08) 0%, rgba(115, 102, 255, 0.08) 100%);
    overflow: hidden;
    border: 1px solid #7366FF;
  }

  .AccountCard-Img-None-Pen {
    position: absolute;
    right: 0px;
    bottom: 0px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .AccountCard-Img-None-text {
    color: #7366FF;
    font-size: 32px;
    font-weight: 700;
    line-height: 41.60px;
    word-wrap: break-word
  }

  .User-MyUsers-Nav {
    background: white;
    box-shadow: 0px 2px 15px rgba(183, 183, 183, 0.30);
    border-radius: 24px;
    padding: 24px;
    gap: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    max-width: 710px;

  }

  .User-MyUsers-Users {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
    align-self: stretch;
  }

  .User-MyUsers-Users-Head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
  }

  .User-MyUsers-AddBtn {
    flex-shrink: 0;
    white-space: nowrap;

    ::v-deep .feather,
    ::v-deep svg {
      color: #fff;
      stroke: #fff !important;
    }

    &:disabled,
    &.disabled {
      ::v-deep .feather,
      ::v-deep svg {
        color: rgba(255, 255, 255, 0.75);
        stroke: rgba(255, 255, 255, 0.75) !important;
      }
    }
  }

  .User-MyUsers-Tabs {
    display: flex;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .User-MyUsers-ListPanel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    align-self: stretch;
    min-height: 200px;
  }

  /* 空态：有效/无效无数据时保留固定高度，避免卡片底部塌缩 */
  .User-MyUsers-Empty {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 200px;
    padding: 48px 32px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    text-align: center;
  }

  .User-MyUsers-Tab-Count {
    margin-left: 4px;
    font-weight: 600;
  }

  .User-MyUsers-Tab {
    flex: 1 1 0;
    appearance: none;
    border: none;
    background: transparent;
    padding: 8px 0 12px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    position: relative;
    text-align: center;

    &.is-active {
      color: #7366ff;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -1px;
        height: 2px;
        background: #7366ff;
        border-radius: 1px;
      }
    }
  }

  /* 名额用尽升级条：背景对齐 RoleQuotaUpgradeModal 头图渐变（图二） */
  .role-quota-noQuota-banner {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    padding: 16px 24px;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    border-radius: 8px;
    background-color: #6231ff;
    background-image: radial-gradient(
      ellipse at 98% 114%,
      #ff7931 0%,
      #e4705d 11%,
      #ca6689 23%,
      #af5db5 34%,
      #9554e2 45%,
      #8550ff 75%,
      #6231ff 100%
    );

    &__nav {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
      flex: 1 1 auto;
    }

    &__icon {
      width: 48px;
      height: 48px;
      flex-shrink: 0;
      object-fit: contain;
    }

    &__body {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 0;
    }

    &__title {
      color: #fff;
      font-size: 14px;
      font-weight: 700;
      line-height: 130%;
    }

    &__desc {
      color: rgba(255, 255, 255, 0.9);
      font-size: 12px;
      font-weight: 400;
      line-height: 150%;
    }

    &__actions {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
      flex-shrink: 0;
    }

    &__learn {
      color: #fff !important;
      font-size: 12px;
      font-weight: 600;
      line-height: 12px;
      text-decoration: none !important;
      white-space: nowrap;
    }

    &__sales {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      border-radius: 8px;
      background: #fff;
      color: #7366ff !important;
      font-size: 12px;
      font-weight: 600;
      line-height: 12px;
      text-decoration: none !important;
      white-space: nowrap;
      cursor: pointer;
    }
  }

  .epo-banner {
    width: 100%;
    border-radius: 12px;
    border: 1px solid;
    padding: 16px;
    display: flex;
    gap: 8px;
    align-items: flex-start;
    box-sizing: border-box;

    &--reminder {
      background: #fffce5;
      border-color: #e98024;
    }

    &--action {
      background: #fcebed;
      border-color: #cd1515;
    }

    &--notify {
      background: #e8f1ff;
      border-color: #2f80ed;
    }
  }

  .epo-banner__plan-icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    display: block;
  }

  .epo-banner__message {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }

  .epo-banner__body {
    min-width: 0;
    flex: 1 1 auto;
    max-width: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .epo-banner__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.8);

    &--action {
      color: #cd1515;
    }

    &--notify {
      color: #1a5bb8;
    }
  }

  .epo-banner__text {
    font-size: 14px;
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.8);
  }

  /* Manage User：与 Contact Sales 同 padding / weight */
  .epo-banner__btn.btn {
    flex-shrink: 0;
    margin: 0;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.154px;
  }

  .epo-banner__cta {
    flex-shrink: 0;
    margin: 0;
    padding: 8px 12px;
    border: 1px solid #7968ff;
    border-radius: 4px;
    background: transparent;
    color: #7366ff;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.154px;
    cursor: pointer;

    &:hover {
      background: rgba(115, 102, 255, 0.06);
    }
  }

  .epo-banner__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
  }

  .AccountCard-Member--inactive {
    font-style: italic;
    color: rgba(0, 0, 0, 0.4);
  }

  .User-MyUsers-Header-Tips {
    color: rgba(0, 0, 0, 0.60);
    font-size: 14px;
    font-weight: 400;
    line-height: 18.20px;
    word-wrap: break-word;

    .User-MyUsers-Header-Tips-Title {
      color: rgba(0, 0, 0, 0.80);
      font-size: 16px;
      font-weight: 700;
      line-height: 20.80px;
      word-wrap: break-word;
      margin-bottom: 4px;
    }

    .User-MyUsers-Header-Tips-P {
      color: rgba(0, 0, 0, 0.60);
      font-size: 14px;
      font-weight: 400;
      line-height: 18.20px;
      word-wrap: break-word;
      letter-spacing: 0px;
    }
  }

  .User-MyUsers-Password {
    width: 100%;
    padding: 16px;
    border-radius: 8px;
    outline: 1px rgba(0, 0, 0, 0.10) solid;
    outline-offset: -1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    gap: 24px;

    .User-MyUsers-Password-Left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;

      .User-MyUsers-Password-Content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
      }
    }
  }

  .User-MyUsers-Password-Note {
    color: rgba(0, 0, 0, 0.80);
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    word-wrap: break-word;
  }

  .User-MyUsers-Password-Masked {
    color: rgba(0, 0, 0, 0.80);
    font-size: 14px;
    font-weight: 700;
    line-height: 18.20px;
    word-wrap: break-word;
  }

  .btn.btn-outline-primary {
    padding: .375rem .75rem;
  }

  .User-MyUsers-Header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 24px;

    .User-MyUsers-Header-Title {
      color: rgba(0, 0, 0, 0.80);
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
      word-wrap: break-word
    }


  }

  .AccountCard {
    padding: 16px;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    outline: 1px rgba(0, 0, 0, 0.10) solid;

    .AccountCard-Img {
      width: 78px;
      display: flex;
      justify-content: center;
      position: relative;
    }

    .AccountCard-Img img {
      width: 78px;
      height: 78px;
      -o-object-fit: contain;
      object-fit: contain;
      border-radius: 999px;
      display: block;
      background: #fff;
    }

    .AccountCard-Info {
      flex: 2;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 8px;

      .AccountCard-Name {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
      }

      .AccountCard-Names {
        color: rgba(0, 0, 0, 0.80);
        font-size: 16px;
        font-weight: 700;
        line-height: 20.80px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
        max-width: 200px;
      }

      .AccountCard-Person {
        padding: 4px 6px;
        background: #F1E7FF;
        border-radius: 25px;
        color: rgba(0, 0, 0, 0.80);
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        word-wrap: break-word;
        text-box-trim: trim-both;
        text-box-edge: cap alphabetic;
        text-align: center;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
      }

      .AccountCard-Member {
        color: rgba(0, 0, 0, 0.60);
        font-size: 12px;
        font-style: italic;
        font-weight: 400;
        line-height: 15.60px;
        word-wrap: break-word
      }

      .AccountCard-Representative {
        padding: 4px 6px;
        background: #ffe7e7;
        border-radius: 25px;
        color: rgba(0, 0, 0, 0.80);
        font-size: 12px;
        font-family: Inter;
        font-weight: 600;
        line-height: 18px;
        word-wrap: break-word;
        text-box-trim: trim-both;
        text-box-edge: cap alphabetic;
        text-align: center;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
      }

      .AccountCardInfoMsg {
        color: rgba(0, 0, 0, 0.60);
        font-size: 14px;
        font-weight: 400;
        line-height: 18.20px;
        word-wrap: break-word;
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .AccountCard-NotSetUp {
        font-size: 12px;
        font-weight: 400;
        line-height: 130%; /* 15.6px */
        color: rgba(0, 0, 0, 0.60);
      }
      
      .AccountCard-Job.AccountCardInfoMsg {
        display: block !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        min-width: 0 !important;
        max-width: 300px !important;
        word-wrap: normal !important;
        width: 100%;
        box-sizing: border-box;
      }
    }

  }

  ::v-deep a.contact-us-link {
    color: #7366FF !important;
    text-decoration: none !important;
    cursor: pointer !important;
    letter-spacing: 0px !important;
  }

  ::v-deep a.contact-us-link:hover {
    color: #5a4ccf !important;
  }
}
</style>
<style lang="scss">
/* 非 scoped 样式，确保动态插入的链接样式生效 */
a.contact-us-link {
  color: #7366FF !important;
  text-decoration: none !important;
  cursor: pointer !important;
  letter-spacing: 0px !important;
}

a.contact-us-link:hover {
  color: #5a4ccf !important;
}

/* 禁用「新增用戶」时 icon 跟白色文字，避免 feather 描边落成黑色 */
.User-MyUsers-AddBtn:disabled svg.feather__content,
.User-MyUsers-AddBtn.disabled svg.feather__content,
.User-MyUsers-AddBtn:disabled .feather svg,
.User-MyUsers-AddBtn.disabled .feather svg {
  stroke: rgba(255, 255, 255, 0.75) !important;
}
</style>